export default __webpack_public_path__ + "static/media/about1.963522ce.jpg";